import script from "./FlyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FlyPage.vue?vue&type=script&setup=true&lang=js"

import "./FlyPage.vue?vue&type=style&index=0&id=33cb7fcf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33cb7fcf"]])

export default __exports__